import NavBar from "./NavBar"
import MenuBar from "./MenuBar"
import "./Header.css"


const Header = () => {
  return (
    <header className="container pt-4">
      <div className="slidebg">
                <div className="slide1"></div>
                <div className="slide2"></div>
                <div className="slide3"></div>
      </div>
      <NavBar />
      <MenuBar />
    </header>

  )
}

export default Header